angular.module('clientDashboardApp').directive('imageValidator', ['$parse', function ($parse) {

  return {
    restrict: 'A',

    link: function(scope, element, attrs) {
      const callback = $parse(attrs['imageValidator'])
      element.on('load', event => {
        scope.$apply(() => {
          callback(scope, {$event: event})
        })
      })
    }
  }
}]);
